import { render } from "./questionCard.vue?vue&type=template&id=17d2340d&ts=true"
import script from "./questionCard.vue?vue&type=script&lang=ts"
export * from "./questionCard.vue?vue&type=script&lang=ts"

import "./questionCard.vue?vue&type=style&index=0&id=17d2340d&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__